import { AnyType } from '@thehubz/shared/model';
import { BRANDMARKE } from './seat/seat-form-fields';
import { Product, SubCategory } from './vorwerk/vorwerk-metadata-config';
export interface TaxonomyModel {
  _id: string;
  name: string;
  linkableArray: string[];
  removedFlag?: boolean;
  categoryName?: string;
}

export const getProductList = (brand: string) => {
  return Product.filter((list) => list.brands.includes(brand));
};

export const getSubCategoryList = (product: string) => {
  return SubCategory.filter((list) => list.products.includes(product));
};

export const getBrandModelListSEAT = (brandMarke?: string, removeFlag?: boolean) => {
  const BRANDMODELL: TaxonomyModel[] = getTaxonomyWithCategoryName('brandModell');
  if (brandMarke) {
    return BRANDMODELL.filter((list: AnyType) => list.linkableArray.includes(brandMarke) && (!removeFlag || (removeFlag && !list.removedFlag)));
  } else {
    return BRANDMODELL;
  }
};

export const getSpecialModelListSEAT = (brandModel?: string[], removeFlag?: boolean) => {
  const SPECIALMODEL: TaxonomyModel[] = getTaxonomyWithCategoryName('specialModel');
  if (brandModel) {
    return SPECIALMODEL.filter((list) => list.linkableArray.some((value) => brandModel.includes(value) && (!removeFlag || (removeFlag && !list.removedFlag))));
  } else {
    return SPECIALMODEL;
  }
};

export const getTrimListSEAT = (brandModel?: string[], removeFlag?: boolean) => {
  const TRIM: TaxonomyModel[] = getTaxonomyWithCategoryName('trim');
  if (brandModel) {
    return TRIM.filter((list) => list?.linkableArray?.some((value) => brandModel.includes(value) && (!removeFlag || (removeFlag && !list.removedFlag))));
  } else {
    return TRIM;
  }
};

export const getDriveListSEAT = (brandModel?: string[], removeFlag?: boolean) => {
  const ANTRIEB: TaxonomyModel[] = getTaxonomyWithCategoryName('drive');
  if (brandModel) {
    return ANTRIEB.filter((list) => list?.linkableArray?.some((value) => brandModel.includes(value) && (!removeFlag || (removeFlag && !list.removedFlag))));
  } else {
    return ANTRIEB;
  }
};

export const getBrandMarkeListSEAT = () => {
  return JSON.parse(JSON.stringify(BRANDMARKE));
};

const getTaxonomyWithCategoryName = (categoryName: string) => {
  const taxonomies: AnyType = localStorage.getItem('taxonomyConfig');
  if (taxonomies && taxonomies != null) {
    const taxonomy = JSON.parse(taxonomies);
    return taxonomy[categoryName];
  }
  return [];
};
